import auStart25 from "./auStart25"


const collection = [
    auStart25
]

export default collection